(ns ycweb.app.website.cart.pages.delivery-method
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.util.core :as u]
   [ycweb.app.website.cart.model :as model]))

;; Simple courier delivery option component
(rum/defc courier-delivery-option < rum/reactive cmn/cursors
  [app-atom cart-summary-atom {:keys [title description disabled? cost yc-staff?]}]
  (let [selected? (= "door" (cmn/curact cart-summary-atom [:cart :delivery :method]))
        price-display
        (let [label (cart.common/delivery-fee-label cost)]
          (cond
            disabled? ""
            ;; staff are always charged courier delivery — mark it with an asterisk
            (and yc-staff? (not= label "Free")) (str label "*")
            :else label))]

    [:li {:class (str "checkout-options-list__item card card--no-hover checkout-option"
                   (when selected? " checkout-option--is-selected")
                   " js-checkout-option")
          :key "door-delivery-option"}
     [:label {:for "door" :class "checkout-option__label checkout-option__label--valign-middle"}
      [:span {:class "checkout-option__content"}
       [:span {:class "checkout-option__indicator"}
        [:input
         {:id "door"
          :name "deliveryoption"
          :value "door"
          :type "radio"
          :class "checkout-option__radio js-checkout-option-radio"
          :checked selected?
          :disabled disabled?
          :on-change
          (fn [e]
            (model/fetch-delivery-list app-atom)
            (swap! cart-summary-atom assoc-in [:cart :delivery :method] "door")
            (model/update-cart-delivery-details app-atom))}]
        [:span {:class "checkout-option__radio-graphic"}]]
       [:span {:class "checkout-option__text"}
        [:span {:class "checkout-option__title"}
         title
         (when description
           [:<> " — " description])
         [:span {:class "u-hidden-from-view"} "."]]]]
      [:span {:class "checkout-option__price"}
       [:span {:class "u-hidden-from-view"} "Price: "]
       price-display]]]))

;; Store collection option component (Yuppiechef retail stores)
(rum/defc store-collection-option < rum/reactive cmn/cursors
  {:did-mount
   (fn [state]
     (let [[_ cart-summary-atom opts] (:rum/args state)
           summary @cart-summary-atom
           store-uuid (get-in summary [:cart :delivery :collection_store_uuid])
           province (get-in summary [:delivery_details "collect" :province])]
       (when (and store-uuid (not province))
         (when-let [point (->> (:collection-points opts)
                            (filter #(= (:uuid %) store-uuid))
                            first)]
           (swap! cart-summary-atom
             #(-> %
                (assoc-in [:delivery_details "collect" :province] (:province point))
                (assoc-in [:delivery_details "collect" :city] (:city point)))))))
     state)}
  [app-atom cart-summary-atom {:keys [title description disabled? cost collection-points]}]
  (let [selected? (= "collect" (cmn/curact cart-summary-atom [:cart :delivery :method]))
        selected-point-uuid
        (cmn/curact cart-summary-atom [:cart :delivery :collection_store_uuid])

        selected-point
        (->>
          collection-points
          (filter #(= (:uuid %) selected-point-uuid))
          first)

        selected-province
        (or
          (cmn/curact cart-summary-atom [:delivery_details "collect" :province])
          (:province selected-point))

        selected-city
        (or
          (cmn/curact cart-summary-atom [:delivery_details "collect" :city])
          (:city selected-point))

        ;; Group collection points by province
        provinces
        (->> collection-points
          (map :province)
          (filter identity) ; Remove nils
          (set)
          (sort))

        ;; Filter cities by selected province
        cities-in-province
        (->> collection-points
          (filter #(= (:province %) selected-province))
          (map :city)
          (set)
          (sort))

        visible-collection-points
        (filter #(and (= (:province %) selected-province)
                   (= (:city %) selected-city)) collection-points)

        price-display
        (if disabled? "" (cart.common/delivery-fee-label cost))]

    [:li {:class (str "checkout-options-list__item card card--no-hover checkout-option"
                   (when selected? " checkout-option--is-selected")
                   " js-checkout-option")
          :key "collect-delivery-option"}
     [:label {:for "collect" :class "checkout-option__label"}
      [:span {:class "checkout-option__content"}
       [:span {:class "checkout-option__indicator"}
        [:input
         {:id "collect"
          :name "deliveryoption"
          :value "collect"
          :type "radio"
          :class "checkout-option__radio js-checkout-option-radio"
          :checked selected?
          :disabled disabled?
          :on-change
          (fn [e]
            (model/fetch-delivery-list app-atom)
            (swap! cart-summary-atom assoc-in [:cart :delivery :method] "collect")
            (model/update-cart-delivery-details app-atom))}]
        [:span {:class "checkout-option__radio-graphic"}]]
       [:span {:class "checkout-option__text"}
        [:span {:class "checkout-option__title"}
         title
         (when description
           [:<> " — " description])
         [:span {:class "u-hidden-from-view"} "."]]]]
      [:span {:class "checkout-option__price"}
       [:span {:class "u-hidden-from-view"} "Price: "]
       price-display]]

     ;; Collection point details with CSS transition animation
     (when (and (seq collection-points) (not disabled?))
       [:div.js-checkout-option-details {:class (u/bem :checkout-option__details [(if selected? :is-open)])}
        ;; Province selector
        (when (seq provinces)
          [:div {:class "checkout-option__select u-max-width-320"}
           (forms/select "Province:"
             (rum/cursor-in cart-summary-atom [:delivery_details "collect" :province])
             (concat
               [{:text "Select a province" :value ""}]
               (map (fn [province] {:text province :value province}) provinces))
             {:class "js-checkout-collect-select"
              :change-fn
              (fn [e]
                (swap! cart-summary-atom
                  #(-> %
                     (assoc-in [:delivery_details "collect" :city] nil)
                     (assoc-in [:cart :delivery :collection_store_uuid] nil))))})])

        ;; City selector
        (when cities-in-province
          [:div {:class "checkout-option__select u-max-width-320"}
           (forms/select "City:"
             (rum/cursor-in cart-summary-atom [:delivery_details "collect" :city])
             (concat
               [{:text "Select a city" :value ""}]
               (map (fn [city] {:text city :value city}) cities-in-province))
             {:class "js-checkout-collect-select"
              :change-fn
              (fn [e]
                (swap! cart-summary-atom
                  assoc-in [:cart :delivery :collection_store_uuid] nil))})])

        ;; Store selector
        [:div {:class "checkout-option__select u-max-width-320"}
         (forms/select "Store:"
           (rum/cursor-in cart-summary-atom [:cart :delivery :collection_store_uuid])
           (concat
             [{:text (if (seq visible-collection-points) "Select a store" "Please select a city first") :value "0"}]
             (map (fn [point] {:text (:name point) :value (:uuid point)}) visible-collection-points))
           {:class "js-checkout-collect-select"})]

        ;; Store address display
        (when (:address selected-point)
          [:div {:class "js-checkout-option-address"}
           [:p {:class "yc-paragraph yc-paragraph--small yc-paragraph--flush u-margin-top-12"}
            [:b (:name selected-point)]
            (when (:maps_link selected-point)
              [:<> " - " [:a {:href (:maps_link selected-point) :target "_blank" :class "text-link"} "Map"]])
            [:br]
            (:address selected-point)
            (when (:address selected-point) [:br])
            (when (and (:suburb selected-point) (not= (:suburb selected-point) (:city selected-point)))
              [:<>
               (:suburb selected-point)
               [:br]])
            (:city selected-point)
            (when (:city selected-point) [:br])
            (:province selected-point)
            (when (:province selected-point) [:br])
            (:postcode selected-point)]])])]))

;; PostNet collection option component
(rum/defc postnet-collection-option < rum/reactive cmn/cursors
  {:did-mount
   (fn [state]
     (let [[_ cart-summary-atom opts] (:rum/args state)
           summary @cart-summary-atom
           point-uuid (get-in summary [:cart :delivery :collection_point_uuid])
           city (get-in summary [:delivery_details "postnet" :city])]
       (when (and point-uuid (not city))
         (when-let [point
                    (->>
                      (:collection-points opts)
                      (filter #(= (:uuid %) point-uuid))
                      first)]
           (swap! cart-summary-atom assoc-in [:delivery_details "postnet" :city] (:city point)))))
     state)}
  [app-atom cart-summary-atom {:keys [title description disabled? cost collection-points]}]
  (let [selected? (= "postnet" (cmn/curact cart-summary-atom [:cart :delivery :method]))
        selected-point-uuid
        (cmn/curact cart-summary-atom [:cart :delivery :collection_point_uuid])

        selected-point
        (->>
          collection-points
          (filter #(= (:uuid %) selected-point-uuid))
          first)

        selected-city
        (or
          (cmn/curact cart-summary-atom [:delivery_details "postnet" :city])
          (:city selected-point))

        ;; Get unique cities for PostNet stores
        cities
        (->> collection-points
          (map :city)
          (set)
          (sort))

        visible-collection-points
        (filter #(= (:city %) selected-city) collection-points)

        price-display
        (if disabled? "" (cart.common/delivery-fee-label cost))]

    [:li {:class (str "checkout-options-list__item card card--no-hover checkout-option"
                   (when selected? " checkout-option--is-selected")
                   " js-checkout-option")
          :key "postnet-delivery-option"}
     [:label {:for "postnet" :class "checkout-option__label"}
      [:span {:class "checkout-option__content"}
       [:span {:class "checkout-option__indicator"}
        [:input
         {:id "postnet"
          :name "deliveryoption"
          :value "postnet"
          :type "radio"
          :class "checkout-option__radio js-checkout-option-radio"
          :checked selected?
          :disabled disabled?
          :on-change
          (fn [e]
            (model/fetch-delivery-list app-atom)
            (swap! cart-summary-atom assoc-in [:cart :delivery :method] "postnet")
            (model/update-cart-delivery-details app-atom))}]
        [:span {:class "checkout-option__radio-graphic"}]]
       [:span {:class "checkout-option__text"}
        [:span {:class "checkout-option__title"}
         title
         (when description
           [:<> " — " description])
         [:span {:class "u-hidden-from-view"} "."]]]]
      [:span {:class "checkout-option__price"}
       [:span {:class "u-hidden-from-view"} "Price: "]
       price-display]]

     ;; Collection point details with CSS transition animation
     (when (and (seq collection-points) (not disabled?))
       [:div.js-checkout-option-details {:class (u/bem :checkout-option__details [(if selected? :is-open)])}

        ;; City selector
        (when collection-points
          [:div {:class "checkout-option__select u-max-width-320"}
           (forms/select "City:"
             (rum/cursor-in cart-summary-atom [:delivery_details "postnet" :city])
             (concat
               [{:text "Select a city" :value ""}]
               (map (fn [city] {:text city :value city}) cities))
             {:class "js-checkout-collect-select"
              :change-fn
              (fn [e]
                (swap! cart-summary-atom
                  assoc-in [:cart :delivery :collection_point_uuid] nil))})])

        ;; Store selector
        [:div {:class "checkout-option__select u-max-width-320"}
         (forms/select "Store:"
           (rum/cursor-in cart-summary-atom [:cart :delivery :collection_point_uuid])
           (concat
             [{:text (if (seq visible-collection-points) "Select a store" "Please select a city first") :value "0"}]
             (map (fn [point] {:text (:name point) :value (:uuid point)}) visible-collection-points))
           {:class "js-checkout-collect-select"})]

        ;; Store address display
        (when (:address selected-point)
          [:div {:class "js-checkout-option-address"}
           [:p {:class "yc-paragraph yc-paragraph--small yc-paragraph--flush u-margin-top-12"}
            [:b (:name selected-point)]
            (when (:maps_link selected-point)
              [:<> " - " [:a {:href (:maps_link selected-point) :target "_blank" :class "text-link"} "Map"]])
            [:br]
            (:address selected-point)
            (when (:address selected-point) [:br])
            (when (and (:suburb selected-point) (not= (:suburb selected-point) (:city selected-point)))
              [:<>
               (:suburb selected-point)
               [:br]])
            (:city selected-point)
            (when (:city selected-point) [:br])
            (:province selected-point)
            (when (:province selected-point) [:br])
            (:postcode selected-point)]])])]))

(rum/defc delivery-options-page < rum/reactive cmn/cursors [app-atom process-atom cart-summary-atom]
  "Step 2: Delivery options page matching step-02.html design"
  (let [{:keys [user] :as cart-summary} (rum/react cart-summary-atom)
        {:keys [collection_charge fee] :as delivery-totals} (get-in cart-summary [:totals :delivery])
        {:keys [collections postnet delivery]} (get-in cart-summary [:options :deliverymethods_enabled])

        hasdropshipitems (model/has-delivery-type-items? cart-summary "dropship")
        has-staff-discount? (model/has-staff-discount? cart-summary)
        yc-staff? (and has-staff-discount? (= (:discount_level user) "Yuppiechef"))

        {:keys [collection_stores postnet_stores]} (cmn/curact app-atom [:delivery-list])]

    (cart.common/checkout-layout process-atom true

      (list

        [:ul {:key "delivery-options" :class "checkout-options-list"}
         (courier-delivery-option app-atom cart-summary-atom
           {:title "Delivery to my door by courier"
            :description
            (when-not yc-staff?
              (str "free for orders over R" (u/currency-format (:threshold delivery-totals))))
            :disabled? (not delivery)
            :cost (:fixed delivery-totals)
            :yc-staff? yc-staff?})

         (when-not hasdropshipitems
           (store-collection-option app-atom cart-summary-atom
             {:title "Collect from a Yuppiechef retail store"
              :description nil
              :disabled? (not collections)
              :cost collection_charge
              :collection-points collection_stores}))

         (when-not hasdropshipitems
           (postnet-collection-option app-atom cart-summary-atom
             {:title "Collect from selected PostNet stores"
              :description nil
              :disabled? (not postnet)
              :cost (:partner_charge delivery-totals)
              :collection-points postnet_stores}))]

        (cart.common/order-calculations app-atom cart-summary-atom))

      (cart.common/checkout-cta-sidebar app-atom process-atom cart-summary-atom
        {:disabled? (model/missing-collection-choice? cart-summary)}))))

(defmethod cart.common/checkout-step :delivery/method
  [app-atom process-atom cart-summary-atom]
  (delivery-options-page app-atom process-atom cart-summary-atom))